<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage"
  >
    <div class="pageTitle">
      {{ "royalDecree.titleList" | translate }}
    </div>
    <div class="filterTableContainer">
      <app-filters
        #insideTable
        [filterList]="filterList"
        [options]="options"
        [ngClass]="{ filterHidden: !showTableFilter }"
        (showFilters)="showFilters($event)"
      ></app-filters>

      <app-table
        [tableList]="tableList"
        [elementList]="listAvailableFields"
        [routing]="routing"
        [numPages]="numPages"
        [numElements]="numElements"
        [totalElements]="totalElements"
        [filterParams]="filtersTableJSON"
        [options]="options"
        [showFilterButtons]="showFilterButtons"
        (valueFilterTable)="filterTable($event)"
        (elementsToRemove)="removeElements($event)"
        (headerButtonsActionEvent)="buttonsHeader($event)"
      ></app-table>

      <div class="formButton">
        <button class="formButtonBack" (click)="goSpecificFields()">
          <em class="fas fa-caret-square-left"></em>
        </button>
      </div>
    </div>
  </div>
</div>
